@if (alertService.showAlert$ | async) {
  <m-banner
    closeable
    [titleLabel]="(alertService.title$ | async) ?? undefined"
    [type]="(color$ | async) ?? 'info'"
    [description]="(alertService.description$ | async) ?? undefined"
    (closed)="onCloseIconClick()" />
}
